module.exports = __webpack_public_path__ + "../assets/fonts/NeutraDisplay-Bold.5bb167b87fd2f9a2bb4b9eb86998ca62.otf";